import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
 async createDepartment(data){
 
    let response = await apiCall("departments/create", data)
    return response;
  },
  async fetchDepartmentsList(data) {
    let response = await apiCall("departments/list", data)
    return response;
  },
  async getDepartmentsCount(data) {
    let response = await apiCall("departments/count", data)
    return response;
  },
}